import PortalContext from './PortalContext';

/** @type {PortalContext} */
let cached;
export function getDefaultPortalContext() {
  if (!cached) {
    cached = new PortalContext({});
  }
  return cached;
}
//# sourceMappingURL=defaultPortalContext.js.map
